export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: "無",
    },
    {
      value: 1,
      name: "Red",
      text: "紅",
    },
    {
      value: 2,
      name: "Orange",
      text: "橙",
    },
    {
      value: 3,
      name: "Green",
      text: "綠",
    },
    {
      value: 4,
      name: "Blue",
      text: "藍",
    },
    {
      value: 5,
      name: "Purple",
      text: "紫",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}

export function getByType(type) {
  const types = getAll().filter(function (item) {
    return item.type == type;
  });
  return types;
}
